"use strict";

require("core-js/modules/es6.array.some");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = filterEvents;

var _contains = _interopRequireDefault(require("../query/contains"));

var _querySelectorAll = _interopRequireDefault(require("../query/querySelectorAll"));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll["default"])(top, selector);
    if (matches.some(function (match) {
      return (0, _contains["default"])(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];